import styled, { createGlobalStyle } from 'styled-components';
import { ReactNode } from 'react';
import { themeColor } from '@hud/web-components/theme/colors';
const Container = styled.div`
  display: none;
  height: 0;
  overflow: hidden;
  transition: all 1.5s cubic-bezier(0.1, 1.04, 0.46, 1.02);
  transition-behavior: allow-discrete;
  font-size: 12px;
  line-height: 18px;
  color: #949494;
  padding-top: 6px;
  padding-left: 34px;
  text-wrap: pretty;

  &.emphasis {
    color: #ffdb31;
  }

  &.open {
    display: block;
    height: 2rem; //backwards compatibility
    height: calc-size(auto, size);
  }

  code {
    font-family: monospace;
    border-radius: 4px;
    border: 1px solid #444547;
    background: #1e1f21;
    padding: 3px 3px;
    color: white;
  }

  p {
    margin: 0;
  }

  a {
    color: ${themeColor('turquoise')};
  }
`;

export const GlobalStyle = createGlobalStyle`
  @starting-style {
    .installationSetupStepTip.open {
      height: 0;
    }
  }
`;

export default function InstallationSetupStepTip({
  children,
  open = false,
  emphasis = false,
}: {
  children?: ReactNode;
  open?: boolean;
  emphasis?: boolean;
}) {
  const classNames = [
    'installationSetupStepTip',
    open ? 'open' : '',
    emphasis ? 'emphasis' : '',
  ];
  return <Container className={classNames.join(' ')}>{children}</Container>;
}
